import React from 'react';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  message?: string;
  confirmText?: string;
};

const CancelConfirmModal: React.FC<Props> = ({ open, onCancel, onConfirm, message, confirmText }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-sm p-6">
        <h2 className="text-lg font-bold mb-4">Confirm</h2>
        <p className="text-sm text-gray-700 mb-6">
          {message ?? 'Do you want to cancel this reservation?'}
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 bg-gray-100 rounded hover:bg-gray-200"
          >
            Stop cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-white bg-red-500 rounded hover:bg-red-600"
          >
            {confirmText ?? 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelConfirmModal;
